import H5Config from '@/config';
import zauth from '@zelos/oauth';
import { PartitionService } from '@zelos/partition';
import { injectClient } from '@zelostech/biz-clue';
import Axios from 'axios';
import { Toast } from 'zarm';

export const usePartitionHeader = 'use-partition';

const baseURL = H5Config.getDerivedAppUrl('gateway');
const request = zauth
  .extend(Axios, {
    redirect_uri: `${window.location.protocol}//${window.location.host}`,
    forward: zauth.CLIENT_FORWARD.H5,
    client_id: H5Config.authClientId,
    client_secret: H5Config.authClientSecret,
    host: `${H5Config.getDerivedAppDomain('auth')}${
      process.env.NODE_ENV !== 'development' &&
      window.location.host.includes(':')
        ? `:${window.location.port}`
        : ''
    }`,
  })
  .create({
    baseURL,
    timeout: 1000 * 60,
  });

injectClient(request);

export const partitionService = PartitionService.getInstance({
  requestClient: request,
  skipPartitionRules: [
    (config) => config.headers[usePartitionHeader] !== 'true',
  ],
});

request.interceptors.response.use((response) => {
  const { success, isSuccess, data, message: msg } = response.data;
  if (success || isSuccess) {
    return { data, success, isSuccess } as any;
  }

  const { messageFree } = response.config as any;

  if (!messageFree) {
    Toast.show(msg);
  }

  return Promise.reject(response.data);
});

export default request;
